export const CHECKOUT_URL =
  'https://sistema-lower-body-360.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#oferta'

export const PRICE = '$19.990'
export const BONUS_VALUE = '$39.950'

export const BRAND = 'CM DIGITAL PRO'
export const PRODUCT = 'SISTEMA LOWER BODY 360°'
export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/6LeY5TWUEsJNMQL5bxe8cC/Imagen_de_Codex_16_sept_2026,_20_21_57.png'

export const pains = [
  {
    title: '😵‍💫 INFORMACIÓN DISPERSA',
    desc: 'Guardas rutinas, ejercicios y videos de redes sociales, pero cada persona recomienda algo diferente y terminas sin saber qué seguir.',
  },
  {
    title: '❓ NO SABES QUÉ HACER PRIMERO',
    desc: 'Hip thrust, sentadillas, peso muerto, zancadas, series, repeticiones, cargas... hay tantas opciones que organizar una rutina parece complicado.',
  },
  {
    title: '🔥 TE FALTA UNA RUTA',
    desc: 'Tienes ganas de trabajar glúteos, piernas y tren inferior, pero necesitas un camino que vaya desde la técnica y los fundamentos hasta una planificación progresiva.',
  },
  {
    title: '😩 SIGUES IMPROVISANDO',
    desc: 'Quieres avanzar, pero pasan las semanas y continúas cambiando ejercicios y rutinas sin saber si realmente estás progresando.',
  },
]

export const modulos = [
  {
    label: 'MÓDULO 1',
    title: 'FUNDAMENTOS LOWER BODY 360°',
    desc: 'Comprende los principales músculos del tren inferior, patrones de movimiento, técnica, postura, respiración, estabilidad y bases para comenzar a entrenar con mayor intención.',
  },
  {
    label: 'MÓDULO 2',
    title: 'ACTIVACIÓN, CALENTAMIENTO Y PREPARACIÓN',
    desc: 'Aprende a preparar tu cuerpo antes de entrenar mediante calentamiento general, movilidad dinámica y protocolos prácticos de 5, 8 y 10 minutos.',
  },
  {
    label: 'MÓDULO 3',
    title: 'EJERCICIOS CLAVE Y TÉCNICA 360°',
    desc: 'Aprende la ejecución de sentadillas, hip thrust, peso muerto rumano, prensa, zancadas, split squat, step-up, extensiones, curls, abducciones y otros movimientos fundamentales.',
  },
  {
    label: 'MÓDULO 4',
    title: 'PROGRESIÓN, INTENSIDAD Y DESARROLLO',
    desc: 'Comprende series, repeticiones, resistencia, descansos, RIR, RPE y sobrecarga progresiva para dejar de entrenar sin saber cómo avanzar.',
  },
  {
    label: 'MÓDULO 5',
    title: 'PLAN LOWER BODY 360°',
    desc: 'Accede a una planificación estructurada de 6 semanas con opciones de 2 o 3 días de tren inferior y alternativas para gimnasio o casa.',
  },
  {
    label: 'MÓDULO 6',
    title: 'RECUPERACIÓN, HÁBITOS Y CONTINUIDAD 360°',
    desc: 'Aprende a integrar recuperación, descanso, organización y hábitos para sostener tu entrenamiento y saber cómo continuar después del programa.',
  },
]

export const bonuses = [
  {
    label: '🎁 BONO 1 — GRATIS',
    title: 'LOWER BODY EXPRESS: RUTINAS DE EMERGENCIA™',
    desc: 'Rutinas rápidas de 10, 15, 20 y 30 minutos para esos días en los que tienes poco tiempo pero quieres mantener tu planificación.',
    value: '$7.990',
  },
  {
    label: '🎁 BONO 2 — GRATIS',
    title: 'BOOTY BUILDER 360°: ESPECIAL GLÚTEOS™',
    desc: 'Una guía estratégica para aprender a seleccionar, ejecutar y progresar ejercicios enfocados en glúteos con mayor intención.',
    value: '$5.990',
  },
  {
    label: '🎁 BONO 3 — GRATIS',
    title: 'PROGRESS TRACKER 360°: DIARIO DE ENTRENAMIENTO™',
    desc: 'Un sistema práctico para registrar ejercicios, series, repeticiones, resistencia, esfuerzo, constancia y evolución durante el programa.',
    value: '$6.990',
  },
  {
    label: '🎁 BONO 4 — GRATIS',
    title: 'GUÍA SWAP 360°: SUSTITUCIÓN INTELIGENTE DE EJERCICIOS™',
    desc: 'Alternativas para adaptar tus ejercicios cuando una máquina está ocupada, entrenas en casa o no dispones del equipamiento habitual.',
    value: '$8.990',
  },
  {
    label: '🎁 BONO 5 — GRATIS',
    title: 'CHALLENGE LOWER BODY 21™',
    desc: 'Un reto de 21 días diseñado para trabajar constancia, organización y continuidad mediante entrenamiento, recuperación y pequeñas acciones.',
    value: '$9.990',
  },
]

export const benefits = [
  {
    title: '🔥 MENOS CONFUSIÓN',
    desc: 'Deja de saltar entre rutinas y ejercicios diferentes y sigue una ruta desde los fundamentos hasta una planificación estructurada.',
  },
  {
    title: '🏋️‍♀️ MÁS CONOCIMIENTO PRÁCTICO',
    desc: 'Comprende ejercicios, técnica, series, repeticiones, intensidad y progresión mediante explicaciones fáciles de aplicar.',
  },
  {
    title: '🍑 ENTIENDE LO QUE ESTÁS HACIENDO',
    desc: 'Empieza a mirar tu rutina y comprender qué estás entrenando, por qué elegiste cada ejercicio y qué función cumple dentro de tu planificación.',
  },
  {
    title: '🚀 UNA NUEVA FORMA DE ENTRENAR',
    desc: 'Construye conocimientos y herramientas que pueden ayudarte a entrenar con mayor autonomía, organización y confianza.',
  },
]

export const testimonials = [
  {
    name: 'Sofía Fernández',
    role: 'Entrena en gimnasio, 27 años',
    place: 'Rosario, Argentina',
    text: 'Tenía un montón de rutinas guardadas y cada semana terminaba haciendo algo diferente. Con el sistema entendí cómo organizar los ejercicios y por primera vez siento que sé qué estoy haciendo cuando entreno.',
  },
  {
    name: 'Camila Ibáñez',
    role: 'Entrena hace 1 año, 31 años',
    place: 'Córdoba, Argentina',
    text: 'Lo que más me sirvió fue el módulo de progresión. Antes hacía siempre las mismas repeticiones y elegía los pesos sin ningún criterio. Ahora entiendo mejor cómo registrar mis entrenamientos y cuándo considerar una progresión.',
  },
  {
    name: 'Laura Quiroga',
    role: 'Principiante, 35 años',
    place: 'Montevideo, Uruguay',
    text: 'Necesitaba algo que me explicara los ejercicios sin complicarme. El módulo de técnica me ayudó a entender mejor sentadillas, peso muerto rumano, hip thrust y otros movimientos que antes hacía simplemente copiando videos.',
  },
  {
    name: 'Carolina Molina',
    role: 'Entrena en casa y gimnasio, 32 años',
    place: 'Santiago, Chile',
    text: 'Siempre empezaba motivada y después terminaba cambiando de rutina. El plan de 6 semanas y el Challenge 21 me dieron una estructura mucho más fácil de seguir y me ayudaron a organizarme mejor.',
  },
  {
    name: 'Mariana Ramírez',
    role: 'Entrenamiento nivel intermedio, 38 años',
    place: 'Guadalajara, México',
    text: 'Pensaba que para entrenar mejor necesitaba encontrar más ejercicios. Con Lower Body 360° entendí que necesitaba aprender a utilizar mejor los que ya tenía, registrar lo que hacía y seguir una planificación.',
  },
]

export const faqs = [
  {
    q: '¿Es físico o digital?',
    a: 'Es un producto 100% digital.',
  },
  {
    q: '¿Necesito experiencia previa?',
    a: 'No. El sistema comienza desde los fundamentos: músculos del tren inferior, patrones de movimiento, postura y técnica básica.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Fundamentos del tren inferior, activación y calentamiento, técnica de los ejercicios clave, progresión e intensidad, planificación de 6 semanas, recuperación y hábitos.',
  },
  {
    q: '¿Incluye rutinas y ejercicios?',
    a: 'Sí. Incluye ejercicios explicados paso a paso, protocolos de calentamiento, rutinas express y un plan estructurado de 6 semanas.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos gratis durante esta oferta.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. El precio de la oferta es $19.990, sin mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Recibes acceso digital después de completar tu compra.',
  },
  {
    q: '¿Necesito entrenar en gimnasio?',
    a: 'No. El plan incluye alternativas para gimnasio y para casa, además de la Guía Swap 360° para sustituir ejercicios según tu equipamiento.',
  },
  {
    q: '¿Puedo avanzar a mi ritmo?',
    a: 'Sí. Puedes seguir el plan y repasar los módulos según tu disponibilidad.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Escríbenos a soportescmdigital@gmail.com.',
  },
]

export const purchaseAlerts = [
  { name: 'Martina Gutiérrez', city: 'Córdoba', country: 'Argentina' },
  { name: 'Agustina Sosa', city: 'Rosario', country: 'Argentina' },
  { name: 'Julieta Domínguez', city: 'La Plata', country: 'Argentina' },
  { name: 'Florencia Peralta', city: 'Mendoza', country: 'Argentina' },
  { name: 'Micaela Benítez', city: 'Mar del Plata', country: 'Argentina' },
  { name: 'Rocío Cabrera', city: 'San Miguel de Tucumán', country: 'Argentina' },
  { name: 'Brenda Ramírez', city: 'Salta', country: 'Argentina' },
  { name: 'Valentina Villalba', city: 'Neuquén', country: 'Argentina' },
  { name: 'Daniela Acosta', city: 'Bahía Blanca', country: 'Argentina' },
  { name: 'Ayelén Medina', city: 'Santa Fe', country: 'Argentina' },
  { name: 'Lucía Ferreyra', city: 'Buenos Aires', country: 'Argentina' },
  { name: 'Antonella Quiroga', city: 'San Juan', country: 'Argentina' },
]
